import React, { Component } from 'react';

class HTMLRender extends Component{

    createMarkup = () => {
        return {__html: this.props.text};
    }
    render(){
        return(
            <div dangerouslySetInnerHTML={this.createMarkup()}/>
        )
    }
}
export default HTMLRender; 